import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'breatheEasyDesc'
})

export class BreatheEasyDescPipe implements PipeTransform {

  private descMap = {
    'score': `<a target="_blank" href="http://blog.getawair.com/how-your-bad-air-quality-affects-you/">Learn How Bad Air Quality Affects You 
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a><br>
    <a target="_blank" href="http://blog.getawair.com/5-air-quality-factors-affecting-your-home/">Learn More About the 5 Air Quality Factors
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a>`,

    'temp': `<a target="_blank" href="http://blog.getawair.com/5-air-quality-factors-affecting-your-home/">Learn More About the 5 Air Quality Factors
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a>`,

    'humid': `<a target="_blank" href="http://blog.getawair.com/5-air-quality-factors-affecting-your-home/">Learn More About the 5 Air Quality Factors
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a>`,

    'co2': `<a target="_blank" href="http://blog.getawair.com/5-air-quality-factors-affecting-your-home/">Learn More About the 5 Air Quality Factors
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a><br>
    <a target="_blank" href="http://blog.getawair.com/how-your-bad-air-quality-affects-you/">Learn How Bad Air Quality Affects You
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a><br>
    <a target="_blank" href="http://blog.getawair.com/why-should-you-care-about-carbon-dioxide/">Learn More About Carbon Dioxide Here
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a>`,

    'voc': `<a target="_blank" href="http://blog.getawair.com/5-air-quality-factors-affecting-your-home/">Learn More About the 5 Air Quality Factors
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a><br>
    <a target="_blank" href="http://blog.getawair.com/how-your-bad-air-quality-affects-you/">Learn How Bad Air Quality Affects You
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a><br>
    <a target="_blank" href="http://blog.getawair.com/do-you-know-which-chemicals-are-in-your-air/">Learn More About VOCs
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a>`,

    'dust': `<a target="_blank" href="http://blog.getawair.com/5-air-quality-factors-affecting-your-home/">Learn More About the 5 Air Quality Factors
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a>`,

    'pm25': `<a target="_blank" href="http://blog.getawair.com/5-air-quality-factors-affecting-your-home/">Learn More About the 5 Air Quality Factors
    <img src="assets/images/timeline/info-popup/link.svg" width="12px"></a>`
  };

  transform(componentType: string): any {
    return this.descMap[componentType];
  }
}
